<div
  class="avatar__mask"
  [ngClass]="'avatar__mask--is-' + avatarType">
  <img
    class="avatar__img"
    [ngClass]="'avatar__img--is-' + avatarType"
    [class.avatar__img--centered]="isCenteredImage"
    [src]="imagePath"
    alt="" />
</div>

<img
  class="avatar__frame"
  [ngClass]="'avatar__frame--is-' + avatarType"
  [src]="avatarPath"
  alt="" />

@if (level > 0) {
  <div
    class="avatar__level g-flex g-flex--align-center g-flex--justify-center text-center"
    [class.app-lvl-default-small]="avatarType !== 'tiny' && avatarType !== 'micro'"
    [class.app-lvl-default-tiny]="avatarType === 'tiny' || avatarType === 'micro'"
    [class.avatar__level--tiny]="avatarType === 'tiny' || avatarType === 'micro'"
    [class.avatar__level--right]="levelToRight"
    [class.color-yellow-fire]="!isShowVirtualLevel"
    [class.app-text-yellow-fire--shadow]="!isShowVirtualLevel"
    [class.color-red-fire]="isShowVirtualLevel"
    [class.text-shadow-negative]="isShowVirtualLevel"
    [class.pointer]="experience > 0"
    (click)="experience > 0 ? switchLevel($event) : null">
    {{ isShowVirtualLevel ? getHeroVirtualLevel(experience, level).toFixed() : level }}
  </div>

  @if (isAbleLevelUp) {
    <img
      class="avatar__level-up"
      src="assets/images/ui/icons/other/level-up.png"
      alt="" />
  }
}

@if (lifeChances >= 0) {
  <app-life-chances
    class="life-chances"
    [lifeChance]="lifeChances">
  </app-life-chances>
}
